// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { xHeaderHandlerType } from "@keller/App/Handlers/XNG/Header";
import { Draft } from "immer";

export type xHeaderStateType = Readonly<{
    isSticky?: boolean;
    registerMenu: string[];
    unregisterMenu: string;
    headerHeight?: number;
    stickyHeight?: number;
    searchQuery: string;
}>;

export const initialHeaderState: xHeaderStateType = {
    isSticky: false,
    registerMenu: [],
    unregisterMenu: "",
    headerHeight: 0,
    stickyHeight: 0,
    searchQuery: "",
};

const reducer = {
    "xHeader/update": (draft: Draft<xHeaderStateType>, action: { data: xHeaderHandlerType }) => {
        if (action.data.key === "registerMenu") {
            if (!action.data.value) {
                return;
            }

            draft.registerMenu.push(action.data.value as string);
            return;
        }

        if (action.data.key === "unregisterMenu") {
            draft.registerMenu = draft.registerMenu.filter(item => item !== action.data.value);
            return;
        }

        if (action.data.key in draft) {
            (draft[action.data.key] as any) = action.data.value as xHeaderStateType[keyof xHeaderStateType];
        }
    },
};

const xHeader = createTypedReducerWithImmer(initialHeaderState, reducer);

(reducers as any).xHeader = xHeader;

export type xHeaderState = {
    xHeader: xHeaderStateType;
} & ApplicationState;

type xHeaderReducers = {
    [key: string]: typeof xHeader;
};

export type xHeaderActions = Parameters<xHeaderReducers[keyof xHeaderReducers]>[1];
